<template>
  <div class="editor-setting-width">
    <div class="editor-setting-header">
      <span>接口入参</span>
      <Icon type="ios-close" @click="$emit('getApiAction')" />
    </div>
    <div class="editor-setting-content">
      <Spin fix v-if="loading">
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>接口请求中...</div>
      </Spin>
      <Form
        class="formInfo"
        ref="formInfo"
        :rules="ruleInline"
        :label-width="120"
        :model="formInfo"
      >
        <FormItem label="接口地址">
          <Input v-model="url" disabled />
        </FormItem>
        <FormItem label="请求方式" style="width: 220px">
          <Input v-model="method" disabled />
        </FormItem>
        <FormItem
          :label="param.name"
          :prop="param.name"
          :key="param.name"
          v-for="param in paramList"
        >
          <Input v-model="formInfo[param.name]" />
        </FormItem>
        <FormItem class="clearfix">
          <div class="float-right">
            <Button type="primary" @click="handleSubmit()">测试</Button>
            <Button
              style="margin-left: 8px"
              @click="$emit('getApiAction')"
              >取消</Button
            >
          </div>
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
import storage from "@dss/js/helper/storage";
import { requestWithSign, ROOT_SERVER } from "@/api";
export default {
  name: "customApiParam",
  props: {
    paramList: {
      type: Array,
      default: () => [],
    },
    url: String,
    method: String,
  },
  created() {
    let ruleDefault = {};
    this.paramList.forEach((param) => {
      if (param.defaultValue === "") {
        ruleDefault[param.name] = [
          {
            required: true,
            message: `${param.desc}不能为空`,
            trigger: "change,blur",
          },
        ];
      }
    });
    this.ruleInline = ruleDefault;
  },
  data() {
    return {
      formInfo: {
        "pageID":0
      },
      ruleInline: {},
      resStatus: {
        //记录接口请求结果
        status: 200,
        sucess: false,
        resp: "",
      },
      errorMsg: "",
      loading: false,
    };
  },
  methods: {
    handleSubmit() {
      //点击测试
      this.$refs["formInfo"].validate((valid) => {
        if (valid) {
          //获取测试凭证并测试接口
          this.$parent.getTicket((ticket) => {
            if (ticket) {
              this.apiticket = {
                time: new Date().getTime(),
                value: ticket,
              };
              //测试接口
              this.testApiservice(ticket);
            } else {
              this.$Message.error("获取测试ticket失败");
            }
          });
        }
      });
    },
    async testApiservice(ticket) {
      this.loading = true;
      let obj = {}; //存储参数
      this.paramList.forEach((item) => {
        if (this.formInfo[item.name] !== "") {
          if (item.type === "number") {
            obj[item.name] = this.formInfo[item.name] - 0;
          } else if (item.type === "string") {
            obj[item.name] = this.formInfo[item.name];
          } else {
            try {
              obj[item.name] = JSON.parse(this.formInfo[item.name]);
            } catch (err) {
              obj[item.name] = this.formInfo[item.name];
            }
          }
        }
      });
      let url = this.url.replace(/^\/+/, "");
      let requestUrl = `${ROOT_SERVER}/data-api-service-rest/${url}`;
      let urlParam = "";
      if (this.method.toUpperCase() === "GET") {
        this.paramList.forEach((item) => {
          if(this.formInfo[item.name]!==undefined){
              urlParam += `&${item.name}=${this.formInfo[item.name]}`;
          }
        });
      }
      if (urlParam.length > 0) {
        requestUrl += `?${urlParam.substring(1)}`;
      }
      let option = {
        method: this.method,
        url: requestUrl,
        token: storage.get("access-user-token", "cookie"),
        ticket,
      };
      if (this.method.toUpperCase() === "POST") {
        option.data = obj;
      }
      let resp = await requestWithSign(option).catch((err) => {
        console.error(e);
        this.loading = false;
        this.errorMsg = "浏览器请求接口报错，错误信息为：" + e;
      });

      if (resp.status && resp.status != 0 && resp.status !== 200) {
        this.resStatus.status = resp.status;
        this.resStatus.sucess = false;
        resp = resp.data;
      } else {
        this.resStatus.status = 200;
        this.resStatus.sucess = true;
      }
      this.loading = false;
      this.resStatus.resp = JSON.stringify(resp, undefined, 4);
      this.$emit("getApiAction", {
        errorMsg: this.errorMsg,
        resStatus: this.resStatus,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.editor-setting-width {
  width: 500px;
  background: #f7f7f7;
  border: 1px solid #dcdee2;
  overflow-y: auto;
  position: absolute;
  top: 32px;
  right: 35%;
  max-height: 400px;
  z-index: 2;
}

.editor-setting-width .editor-setting-header {
  border-bottom: 1px solid #e8eaec;
  padding: 10px 16px;
  line-height: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
}

.ivu-icon {
  display: inline-block;
  font-family: Ionicons;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  text-rendering: optimizeLegibility;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  vertical-align: -0.125em;
  text-align: center;
  font-size: 26px;
}
.editor-setting-content {
  padding: 10px;
}
.formInfo {
  padding: 10px 30px 10px 0;
  background: #fff;
}
.demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
</style> 
  
